module.exports = __webpack_public_path__ + "img/gold.3c376778.svg";